export default __webpack_public_path__ + "static/media/speedyHamby.a6d0a70c.png";